import { render, staticRenderFns } from "./showLandInformation.vue?vue&type=template&id=472dfc51&"
import script from "./showLandInformation.vue?vue&type=script&lang=js&"
export * from "./showLandInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports